<div mat-dialog-title>
  <div class="title-container">
    <div class="title-text-container">
      @if (data.displayTitleIcon) {
        <mat-icon class="locked">lock</mat-icon>
      }
      <h2 class="reason">{{ data.reason }}</h2>
    </div>
    <button
      type="button"
      class="close"
      mat-icon-button
      [mat-dialog-close]="true"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content>{{ data.callToAction }} </mat-dialog-content>
<mat-dialog-actions>
  <a mat-flat-button class="primary" [href]="externalUrls.LineupUpgrade">
    Contact Us To Upgrade
  </a>
  <a mat-stroked-button [href]="externalUrls.LineupPricing">
    View Upgrade Options
  </a>
</mat-dialog-actions>
